import { render, staticRenderFns } from "./ipWhiteList.vue?vue&type=template&id=4c9b52d0&scoped=true&"
import script from "./ipWhiteList.vue?vue&type=script&lang=js&"
export * from "./ipWhiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b52d0",
  null
  
)

export default component.exports